// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ContextMenu_toggleButton__HpgbJ","menuItem":"ContextMenu_menuItem__jCrwN","menuItemIcon":"ContextMenu_menuItemIcon__3Vs5W"};